import React, { useEffect, useState } from "react";
import FormBuilder from "../form_components/FormBuilder";
import MultiSelect, { SelectionOption } from "../form_components/MultiSelect";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { fetchEventTypes, fetchHandles } from "../../features/Actions/ActionSlice";
import Input from "../form_components/Input";
import { useNotification } from "../../context/NotificationContext";
import IprojectData from "../../interfaces/projectData.interface";
import dayjs from "dayjs";
import { fetchProjects, fetchUsedProjects } from "../../features/Project/ProjectSlice";
import Button from "../Button";

type SelectProjectProps = {
  onSubmit: (project:IprojectData) => void;
};

export default function SelectProject(
    {onSubmit}:SelectProjectProps
) {
    const dispatch = useAppDispatch();
    const { notify } = useNotification();
    const current_project = useAppSelector(state => state.Projects.current_project);
    const projects = useAppSelector(state => state.Projects.used_projects);
    const [selected, setSelected] = useState(current_project);
    const [output, setOuput] = useState([] as IprojectData[]);

    

    useEffect(() => {
        setOuput(projects);
    }, [projects]);


    const onClick = async () => {
        if(selected){
            onSubmit(selected);
        }
    };

    const changeSelected = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const id = Number(event.target.value); // convert from string to number

        const project = projects.find(p => p.id === id);

        if (project) {
            setSelected(project);
        }
    };

    return (
        <FormBuilder title="Select Project" onSubmit={onClick}>
            <select className="border rounded dark:bg-ndgray dark:border-black w-full" onChange={(event) => {changeSelected(event)}}>
                <option value='0'></option>
                {output.map((project: IprojectData) => (
                    <option key={project.id} value={project.id}>
                        {project.mfp_id} - {project.name} - {dayjs(project.start_date).format("YYYY-MM-DD")}
                    </option>
                ))}
            </select>
        </FormBuilder>
    );
}